// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"c5d3b575","256":"552d3014","351":"fa716d00","384":"19225b0b","632":"d2440e93","696":"f6ea0d0b","787":"c279a4e2","970":"cba054bf"}[chunkId] + ".chunk.js";
};